
import crtBg from '@/assets/images/qycertificate.png'
export default class Certificate {
  constructor(name, curriculum, time, companyName, index, callback) {
    // console.log('dataarguments',arguments)
    this.name = name
    this.curriculum = curriculum
    this.time = time
    this.year = ''
    if (time && time.indexOf('-') !== -1) {
      this.year = time.split('-')[0]
    }
    this.companyName = companyName
    this.callback = callback
    this.index = index
    this.imgWidth = 500
    this.imgHeight = 360
    this.content = ''
    this.initMethod()
  }

  initMethod() {
    const img = new Image()
    const that = this
    img.src = crtBg
    img.onload = function() {
      that.createCanvas(img)
    }
  }

  createCanvas(imageItem) {
    var canvas = document.createElement('canvas') // 创建canvas元素
    canvas.width = this.imgWidth // canvas宽度
    canvas.height = this.imgHeight // canvas的高度
    var context = canvas.getContext('2d') // 创建渲染
    context.fillStyle = '#fff'
    context.fillRect(0, 0, this.imgWidth, this.imgHeight)
    context.drawImage(imageItem, 0, 0, this.imgWidth, this.imgHeight)

    this.setTitleText(196, 80, '参加培训证明', context)

    // 开始绘制文本
    this.setText(80, 125, '员工', context)
    // 姓名
    this.setText(120, 125, this.name, context)
    this.setLine(114, 128, 180, 128, context)

    // 年限 + 课程
    this.setText(110, 155, '参加', context)
    this.setText(141, 155, this.year + '年' + this.curriculum.slice(0, 24), context)
    this.setLine(140, 158, 420, 158, context)
    if (this.curriculum.length > 24) {
      this.setText(80, 185, this.curriculum.slice(24), context)
      this.setLine(80, 188, 420, 188, context)
    }
    this.setText(140, 215, '考核合格，特此证明！', context)
    // 年限
    // this.setText(50, 165, this.year, context)
    // 公司
    this.setText(240, 265, '证明单位：' + this.companyName, context)
    // 时间
    this.setText(300, 295, this.time, context)
    var fullQuality = canvas.toDataURL('image/jpeg', 1.0)
    this.callback(fullQuality, this.index)
  }

  setText(x, y, text, cans) {
    cans.font = 'bold 12px arial'
    cans.fillStyle = '#000000'
    cans.fillText(text, x, y)
  }

  setLine(x1, y1, x2, y2, context) {
    context.moveTo(x1,y1)
    context.lineTo(x2,y2)
    context.stroke()
  }

  setTitleText(x, y, text, cans) {
    cans.font = 'bold 18px SimSun'
    cans.fillStyle = '#000000'
    cans.fillText(text, x, y)
  }

  // 获取字符串的真实长度（字节长度）
  getTrueLength(str) {
    var len = str.length; var truelen = 0
    for (var x = 0; x < len; x++) {
      if (str.charCodeAt(x) > 128) {
        truelen += 2
      } else {
        truelen += 1
      }
    }
    return truelen
  }
}
